import { State } from './types'

export const INITIAL_STATE: State = {
  page: undefined,
  subpage: undefined,
  subsubpage: undefined,
}
